var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSimulator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41699 9.9165H7.58366V6.4165H6.41699V9.9165ZM7.00033 5.24984C7.1656 5.24984 7.30424 5.19384 7.41624 5.08184C7.52824 4.96984 7.58405 4.83139 7.58366 4.6665C7.58327 4.50161 7.52727 4.36317 7.41566 4.25117C7.30405 4.13917 7.1656 4.08317 7.00033 4.08317C6.83505 4.08317 6.6966 4.13917 6.58499 4.25117C6.47338 4.36317 6.41738 4.50161 6.41699 4.6665C6.4166 4.83139 6.4726 4.97003 6.58499 5.08242C6.69738 5.19481 6.83583 5.25061 7.00033 5.24984ZM7.00033 12.8332C6.19338 12.8332 5.43505 12.6799 4.72533 12.3735C4.0156 12.0671 3.39824 11.6515 2.87324 11.1269C2.34824 10.6023 1.93272 9.98495 1.62666 9.27484C1.3206 8.56473 1.16738 7.80639 1.16699 6.99984C1.1666 6.19328 1.31983 5.43495 1.62666 4.72484C1.93349 4.01473 2.34902 3.39737 2.87324 2.87275C3.39747 2.34814 4.01483 1.93262 4.72533 1.62617C5.43583 1.31973 6.19416 1.1665 7.00033 1.1665C7.80649 1.1665 8.56483 1.31973 9.27533 1.62617C9.98583 1.93262 10.6032 2.34814 11.1274 2.87275C11.6516 3.39737 12.0674 4.01473 12.3746 4.72484C12.6818 5.43495 12.8348 6.19328 12.8337 6.99984C12.8325 7.80639 12.6793 8.56473 12.374 9.27484C12.0687 9.98495 11.6532 10.6023 11.1274 11.1269C10.6016 11.6515 9.98427 12.0673 9.27533 12.3741C8.56638 12.6809 7.80805 12.8339 7.00033 12.8332Z",
    fill: "#C5C5CB",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSimulator);
export default __webpack_public_path__ + "static/media/info-Simulator.f6aaeffe3c8d489b405d91e3492f8b12.svg";
export { ForwardRef as ReactComponent };